export default [
    "Clientes",
    "Produtos",
    "Verbas",
    "Resumo",
  ];